import React from 'react';

// Styles & Assets
import styles from './NonTakenOptions.module.css';

// Hooks
import { useTranslation } from 'react-i18next';

// Components
import CircleSelector from '../../UI/CircleSelector/CircleSelector';

// Interfaces
interface Props {
    forgotten: boolean
    handleSetForgotten: (forgot: boolean) => void
    defaultComment: string
    small?: boolean
    handleChangeComment: (comment: string) => void
}

const NonTakenOptions: React.FC<Props> = ({ forgotten, handleSetForgotten, defaultComment, handleChangeComment, small }) => {

    const { t } = useTranslation();

    const classTextArea = small ? styles.smallText : '';
    const nonTakenSmall = small ? styles.nonTakenSmall : undefined;

    const onChangeComment = (evt: React.ChangeEvent<HTMLTextAreaElement>) => {
        handleChangeComment(evt.target.value);
    };

    return (
        <div className={`${styles.nonTakenOptions} ${nonTakenSmall} `}>
            <CircleSelector
                text={t('forgotten')}
                active={forgotten}
                handleClick={() => handleSetForgotten(true)}
            />
            <CircleSelector
                text={t('another_reason')}
                active={!forgotten}
                handleClick={() => handleSetForgotten(false)}
            />
            {!forgotten &&
                <textarea
                    onChange={onChangeComment}
                    className={classTextArea}
                    placeholder={t('specify_reason') as string}
                    defaultValue={defaultComment}
                ></textarea>
            }
        </div>
    );
};

export default NonTakenOptions;